import React from 'react'
import { connect } from 'react-redux'
import {
    createTypeCertificate, editTypeCertificate,
    seeListTypesCertificates, deleteTypeCertificate
} from '../../actions/certificationActions'
import { Switch, Link } from 'react-router-dom';
import { RouteWithSubRoutes } from '../../../config/Router';

const InventoryRoot = ({ routes }) => {

    return <Switch>
        {routes.map((route, i) => (
            <RouteWithSubRoutes key={i} {...route} />
        ))}
    </Switch>

}


export default InventoryRoot